import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';

export interface SubmitFormSliceState {
  isRedirectFailed: boolean;
  iFrameHeight?: number;
  isFrameHeightEqualsPlatformHeight?: boolean;
  isRedirectBlank: boolean;
  isRedirectTypeRedirect: boolean;
  /** true when SubmitForm is mounted (iframe/redirect after payment submit) */
  isSubmitFormActive: boolean;
}

export const initialState: SubmitFormSliceState = {
  isRedirectFailed: true,
  isRedirectBlank: false,
  isRedirectTypeRedirect: false,
  isSubmitFormActive: false,
};

const submitFormSlice = createSlice({
  name: 'submitForm',
  initialState,
  reducers: {
    setIsRedirectBlank(state, action: PayloadAction<boolean>) {
      state.isRedirectBlank = action.payload;
    },
    setIsRedirectTypeRedirect(state, action: PayloadAction<boolean>) {
      state.isRedirectTypeRedirect = action.payload;
    },
    resetSubmitRedirectError: (state) => {
      state.isRedirectFailed = false;
      state.isRedirectBlank = false;
      state.isRedirectTypeRedirect = false;
    },
    setSubmitFormSettings: (state, action) => {
      state.iFrameHeight = action.payload.iFrameHeight;
      state.isFrameHeightEqualsPlatformHeight = action.payload.isFrameHeightEqualsPlatformHeight;
    },
    setSubmitFormActive: (state, action: PayloadAction<boolean>) => {
      state.isSubmitFormActive = action.payload;
    },
  },
});

export const submitRedirectErrorSelector = ({ submitForm }: { submitForm: SubmitFormSliceState }) =>
  submitForm.isRedirectFailed;

export const submitFormSettingsSelector = createSelector(
  (state: { submitForm: SubmitFormSliceState }) => state.submitForm,
  (submitForm) => ({
    iFrameHeight: submitForm.iFrameHeight,
    isFrameHeightEqualsPlatformHeight: submitForm.isFrameHeightEqualsPlatformHeight,
  }),
);

export const submitRedirectBlankSelector = ({ submitForm }: { submitForm: SubmitFormSliceState }) =>
  submitForm.isRedirectBlank;

export const submitRedirectTypeRedirectSelector = ({ submitForm }: { submitForm: SubmitFormSliceState }) =>
  submitForm.isRedirectTypeRedirect;

export const isSubmitFormActiveSelector = ({ submitForm }: { submitForm: SubmitFormSliceState }) =>
  submitForm.isSubmitFormActive;

export const {
  resetSubmitRedirectError,
  setIsRedirectBlank,
  setIsRedirectTypeRedirect,
  setSubmitFormSettings,
  setSubmitFormActive,
} = submitFormSlice.actions;

export default submitFormSlice.reducer;
